import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { FIELD_TYPES } from '../../constants';
import { groupFieldsByOrder } from '../utils';
import { FileField, PhoneField, TextareaField, TextField } from './fields';

const FIELD_COMPONENTS = {
  [FIELD_TYPES.TEXT]: TextField,
  [FIELD_TYPES.EMAIL]: TextField,
  [FIELD_TYPES.TEXTAREA]: TextareaField,
  [FIELD_TYPES.PHONE]: PhoneField,
  [FIELD_TYPES.FILE]: FileField
};

const TicketFormFields = ({
  fields,
  values,
  onFieldChange,
  onFieldBlur,
  fieldHelperText,
  fieldErrors,
  disabled = false
}) => {
  const rows = groupFieldsByOrder(fields);

  return (
    <Box data-testid="ticket-form-fields" sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {rows.map(row => (
        <Box
          key={row.map(field => field.id).join('-')}
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: `repeat(${row.length}, 1fr)` },
            gap: 3,
            alignItems: 'start'
          }}
        >
          {row.map(field => {
            const FieldComponent = FIELD_COMPONENTS[field.type];
            if (!FieldComponent) {
              return null;
            }

            return (
              <Box key={field.id} data-testid={`ticket-field-${field.id}`}>
                <FieldComponent
                  field={field}
                  value={values[field.id]}
                  onChange={value => onFieldChange(field.id, value)}
                  onBlur={() => onFieldBlur(field.id)}
                  helperText={fieldHelperText?.[field.id]}
                  errorText={fieldErrors?.[field.id]}
                  disabled={disabled}
                />
              </Box>
            );
          })}
        </Box>
      ))}
    </Box>
  );
};

TicketFormFields.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  values: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  fieldHelperText: PropTypes.objectOf(PropTypes.string),
  fieldErrors: PropTypes.objectOf(PropTypes.string),
  disabled: PropTypes.bool
};

TicketFormFields.defaultProps = {
  fieldHelperText: {},
  fieldErrors: {}
};

export default TicketFormFields;
